import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import styles from './Header.scss';

const navLinks = [
  { path: './', label: 'Home' },
  { path: '/what-we-stand-for', label: 'What We Stand For' },
  { path: '/how-to-use-abortion-pills', label: 'How to Use Abortion Pills' },
  { path: '/aftercare', label: 'Aftercare' },
  {
    path: '/who-are-community-providers',
    label: 'Who are Community Providers',
  },
  { path: '/coverage', label: 'Coverage' },
];

const navLinksEs = [
  {
    path: '/en-español/acceso-en-los-estados-rojos',
    label: 'Acceso en los Estados Rojos',
  },
  { path: '/en-español/recursos', label: 'Recursos' },
  {
    path: '/en-español/como-usar-las-pastillas-para-abortar',
    label: 'Como usar las pastillas para abortar',
  },
];

export default function Header() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const toggleScrolled = () => {
      const selectBody = document.querySelector('body');
      const selectHeader = document.querySelector('#header');
      if (!selectHeader) return;

      const hasStickyClass =
        selectHeader.classList.contains('scroll-up-sticky') ||
        selectHeader.classList.contains('sticky-top') ||
        selectHeader.classList.contains('fixed-top');

      if (!hasStickyClass) return;

      if (window.scrollY > 100) {
        selectBody.classList.add('scrolled');
      } else {
        selectBody.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', toggleScrolled);
    toggleScrolled();

    return () => {
      window.removeEventListener('scroll', toggleScrolled);
    };
  }, []);

  useEffect(() => {
    const body = document.querySelector('body');
    const mobileNavToggleBtn = document.querySelector('.mobile-nav-toggle');

    function mobileNavToggle() {
      body.classList.toggle('mobile-nav-active');
      mobileNavToggleBtn?.classList.toggle('bi-list');
      mobileNavToggleBtn?.classList.toggle('bi-x');
    }

    mobileNavToggleBtn?.addEventListener('click', mobileNavToggle);

    const navLinks = document.querySelectorAll('#navmenu a');

    navLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        if (link.classList.contains('dropdown-toggle')) {
          e.preventDefault();
          return;
        }

        if (body.classList.contains('mobile-nav-active')) {
          mobileNavToggle();
        }
      });
    });

    // const dropdownToggles = document.querySelectorAll(
    //   '.navmenu .toggle-dropdown',
    // );
    // dropdownToggles.forEach((toggle) => {
    //   toggle.addEventListener('click', function (e) {
    //     e.preventDefault();
    //     this.parentNode.classList.toggle('active');
    //     this.parentNode.nextElementSibling?.classList.toggle('dropdown-active');
    //     e.stopImmediatePropagation();
    //   });
    // });

    return () => {
      mobileNavToggleBtn?.removeEventListener('click', mobileNavToggle);
      navLinks.forEach((link) =>
        link.removeEventListener('click', mobileNavToggle),
      );
      // dropdownToggles.forEach((toggle) =>
      //   toggle.removeEventListener('click', mobileNavToggle),
      // );
    };
  }, []);

  return (
    <header
      id="header"
      className={`${styles.header} header d-flex align-items-center fixed-top`}
    >
      <div className="container-fluid container-xl position-relative">
        <div className="d-flex align-items-center justify-content-between w-100">
          <Link
            to="/"
            className={`${styles.logo} logo d-flex align-items-center fs-4`}
          >
            Free Medication Abortion
          </Link>
          <nav id="navmenu" className={`${styles.navmenu} navmenu`}>
            <ul>
              {navLinks.map(({ path, label }) => (
                <li key={label}>
                  <NavLink
                    to={path}
                    className={({ isActive }) =>
                      isActive ? `${styles.active} active nav-link` : 'nav-link'
                    }
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdown"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  En Español
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                  {navLinksEs.map(({ path, label }) => (
                    <li key={label}>
                      <NavLink
                        to={path}
                        className={({ isActive }) =>
                          isActive
                            ? `${styles.active} active dropdown-item`
                            : 'dropdown-item'
                        }
                      >
                        {label}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </li>
            </ul>
            <i className="d-xl-none bi bi-list mobile-nav-toggle"></i>
          </nav>
        </div>
      </div>
    </header>
  );
}
